import { useEffect, useState } from "react";
import { api } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Archive, CheckCircle2, AlertTriangle, XCircle, ClipboardCheck, ArrowRight } from "lucide-react";

// Perlu dicek bila belum pernah dicek atau terakhir dicek > 1 tahun lalu
const perluDicek = (tglCek) => {
  if (!(tglCek || "").trim()) return true;
  const d = new Date(`${tglCek.slice(0, 10)}T00:00:00`);
  if (isNaN(d)) return true;
  return (Date.now() - d.getTime()) / 86400000 > 365;
};

export default function AssetSummaryCard({ onNavigate }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/asset").then((res) => setRows(res.data)).catch(() => {});
  }, []);

  const stat = (fn) => (rows ? rows.filter(fn).length : "-");

  return (
    <Card className="p-6 border-slate-200 shadow-none rounded-lg" data-testid="asset-summary-card">
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => onNavigate?.("asset")} data-testid="goto-asset"
          className="flex items-center gap-2 group" title="Buka modul Pencatatan Asset">
          <Archive className="h-4 w-4 text-indigo-600" />
          <h3 className="text-base font-semibold text-slate-900 group-hover:text-indigo-600 transition-colors">Pencatatan Asset</h3>
          <ArrowRight className="h-3.5 w-3.5 text-slate-300 group-hover:text-indigo-600 group-hover:translate-x-0.5 transition-all" />
        </button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {[
          { icon: Archive, label: "Total Asset", value: rows?.length ?? "-", tone: "text-indigo-600 bg-indigo-50" },
          { icon: CheckCircle2, label: "Kondisi Baik", value: stat((r) => r.kondisi === "BAIK"), tone: "text-emerald-600 bg-emerald-50" },
          { icon: AlertTriangle, label: "Rusak Ringan", value: stat((r) => r.kondisi === "RUSAK RINGAN"), tone: "text-amber-600 bg-amber-50" },
          { icon: XCircle, label: "Rusak Berat", value: stat((r) => r.kondisi === "RUSAK BERAT"), tone: "text-rose-600 bg-rose-50" },
          { icon: ClipboardCheck, label: "Perlu Dicek (>1 th)", value: stat((r) => perluDicek(r.tgl_cek)), tone: "text-blue-600 bg-blue-50" },
        ].map((s, i) => (
          <div key={s.label} className="rounded-xl border border-slate-100 bg-slate-50/60 p-4 flex items-center gap-4"
            data-testid={`asset-summary-item-${i}`}>
            <div className={`h-12 w-12 rounded-xl flex items-center justify-center shrink-0 ${s.tone}`}>
              <s.icon className="h-6 w-6" />
            </div>
            <div className="min-w-0">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-500">{s.label}</p>
              <p className="text-2xl font-black text-slate-900 truncate">{s.value}</p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
